(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.StackhouseGeneratedDiscountReadiness = api;
})(typeof window === 'object' ? window : this, function () {
  'use strict';

  function pendingError() {
    var error = new Error('Your custom print is still being prepared. Please try again in a moment.');
    error.code = 'GENERATED_DISCOUNT_PENDING';
    error.generatedDiscountPending = true;
    return error;
  }

  function createWaiter(dependencies) {
    dependencies = dependencies || {};
    var now = dependencies.now || Date.now;
    var sleep = dependencies.sleep || function (ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); };
    // Fresh products can take over a minute to enter native discount collections.
    var maximumWait = 120000;
    return async function waitFor(options) {
      var product = options.product || {};
      if (!product.discount_readiness_token || !product.product_id || !product.variant_id) throw pendingError();
      var request = options.fetch;
      var deadline = now() + maximumWait;
      for (var attempt = 0; attempt < 80 && now() < deadline; attempt++) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, Math.min(2500, deadline - now()));
        try {
          var response = await request(options.apiBaseUrl + '/create-orders/ajax/generated-discount-readiness/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, cache: 'no-store',
            body: JSON.stringify({ token: product.discount_readiness_token }), signal: controller.signal
          });
          if (response.status === 403 || response.status === 410) {
            var expired = new Error('This custom print could not be verified. Please try again.');
            expired.code = 'GENERATED_DISCOUNT_TOKEN_INVALID';
            throw expired;
          }
          var data = await response.json();
          if (response.ok && data.ok === true && data.ready === true &&
              String(data.product_id) === String(product.product_id) &&
              String(data.variant_id) === String(product.variant_id)) return;
        } catch (error) {
          if (error.code === 'GENERATED_DISCOUNT_TOKEN_INVALID') throw error;
        } finally {
          clearTimeout(timer);
        }
        if (now() < deadline) await sleep(Math.min(1500, deadline - now()));
      }
      throw pendingError();
    };
  }

  return { waitFor: createWaiter(), createWaiter: createWaiter };
});
